const Skeleton = ({ w, h, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: 6,
    background: "rgba(255,255,255,0.18)",
    animation: "pulse 1.4s ease-in-out infinite",
    ...style,
  }} />
);

export default function WelcomeCard({
  loading,
  user,
  activePrescriptionCount = 0,
  pendingRefillCount      = 0,
  totalPrescriptionCount  = 0,
}) {
  const hour     = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  const fullName = user
    ? `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim()
    : "";

  const stats = [
    { value: activePrescriptionCount, label: "Active Prescriptions" },
    { value: pendingRefillCount,      label: "Pending Refills"       },
    { value: totalPrescriptionCount,  label: "Total Prescriptions"   },
  ];

  return (
    <>
      {/* keyframes injected once */}
      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}`}</style>

      <div className="welcome-card">
        <div className="welcome-card-greeting">{greeting}</div>

        {loading ? (
          <Skeleton w={180} h={28} style={{ marginBottom: 6 }} />
        ) : (
          <h2 className="welcome-card-name">{fullName || "Welcome back"}</h2>
        )}

        <p className="welcome-card-subtitle">
          Here's an overview of your health activity today.
        </p>

        <div className="welcome-card-stats">
          {stats.map((s, i) => (
            <div key={s.label} style={{ display: "flex", alignItems: "stretch", gap: 28 }}>
              {i > 0 && (
                <div style={{ width: 1, background: "rgba(255,255,255,0.2)" }} />
              )}
              <div className="welcome-stat">
                {loading ? (
                  <Skeleton w={32} h={26} style={{ marginBottom: 4 }} />
                ) : (
                  <span className="welcome-stat-value">{s.value}</span>
                )}
                <span className="welcome-stat-label">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
